module.exports = function getResource(label, vars = []) {
    const resources = {
        biAccountRequiredText: 'Vous devez avoir un compte Beauty Insider pour déposer une demande de carte de crédit Sephora.',
        birthdayForAutoEnrolledMessage: 'Saisissez votre date de naissance pour recevoir un cadeau gratuit pendant le mois de votre anniversaire. C’est l’un des nombreux avantages des membres Beauty Insider.',
        birthdayForNotAutoEnrolledMessage: 'Inscrivez-vous à notre programme de récompense pour gagner des points à chaque achat, un cadeau d’anniversaire, des échantillons et des expériences uniques.',
        enterBirthdayForGiftText: 'Enter your birthday to receive a free gift every year.',
        signupAndEarnText: `Inscrivez-vous et obtenez *${vars[0]} point${vars[0] > 1 ? 's' : ''}* de la commande d'aujourd'hui`,
        joinAndAgree: 'Devenir membre et accepter ',
        termsAndConditionsLink: 'Modalités',
        biTermsAndConditionsLink: 'Modalités Beauty Insider',
        joinCheckboxLabel: 'Inscrivez-vous au programme de récompenses gratuit de Sephora et gagnez des points sur chaque achat.',
        byUncheckingMessage: 'En décochant la case ci-dessus, vous vous inscrivez uniquement à Sephora.com.',
        byJoiningText: 'En vous inscrivant, vous acceptez notre',
        automaticEmailOffersText: ' et vous recevrez automatiquement des offres Beauty Insider par courriel',
        enterBirthdayText: 'Enter your birthday to receive a free gift every year.',
        testEnterBirthdayText: 'Entrez votre date d’anniversaire pour recevoir votre cadeau d’anniversaire annuel.'
    };
    return resources[label];
};
